import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

interface IHeightSelector {
  value: string
  onChange: (newValue: string) => void
}

export const HeightSelector = ({ value, onChange }: IHeightSelector) => {
  const data = useMemo(() => {
    return [
      {
        label: 'Auto - wrap has auto height',
        value: 'auto',
      },
      {
        label: 'Fixed - without header and footer',
        value: 'var(--sb_header-height_fixed-only-body)',
      },
      {
        label: 'Fixed - without header',
        value: 'var(--sb_header-height_fixed-without-header)',
      },
      {
        label: '100% by screen',
        value: '100vh',
      },
      {
        label: '75% by screen',
        value: '75vh',
      },
      {
        label: '50% by screen',
        value: '50vh',
      },
      {
        label: '25% by screen',
        value: '25vh',
      },
      {
        label: 'Custom value',
        value: 'custom',
      },
    ]
  }, [])

  const heightCrud = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(data),
      keyField: 'value',
    })
  }, [data])

  return (
    <Dropdown
      caption={'label'}
      source={heightCrud}
      label="Height"
      value={value}
      onChange={onChange}
    />
  )
}
